import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ResearchPaperDTO, ScreeningResultDTO} from '../../dto/research-paper';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent} from '@angular/material/dialog';
import {ScreeningCriteriasResultsComponent} from '../screening-criterias-results/screening-criterias-results.component';
import {MatButtonModule} from '@angular/material/button';

interface ScreeningCriteriasResultsDialog{
  result: ScreeningResultDTO[];
  paper: ResearchPaperDTO;
  isScreeningOne: boolean;
  runId: number;
  editable: boolean;
}
@Component({
  selector: 'app-screening-criterias-results-dialog',
  imports: [
    MatDialogContent,
    ScreeningCriteriasResultsComponent,
    MatButtonModule,
    MatDialogActions,
    MatDialogClose
  ],
  templateUrl: './screening-criterias-results-dialog.component.html',
  styleUrl: './screening-criterias-results-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreeningCriteriasResultsDialogComponent {
  readonly data: ScreeningCriteriasResultsDialog = inject<ScreeningCriteriasResultsDialog>(MAT_DIALOG_DATA);

}
